import { useEffect, useState } from "react";
import { getAuthProvider } from "@/providers/authProvider/authProviderInstance";
import { SchemaDefinitionsResponse } from "@/types/schemaDefinitions";
import { getPartnerAwareApiUrl } from "@/providers/dataProvider/dataProvider";

export const useSchemaDefinitions = () => {
  const [data, setData] = useState<SchemaDefinitionsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchSchemas = async () => {
      try {
        setLoading(true);

        const authProvider = getAuthProvider();
        const token = authProvider && authProvider.getAccessToken ? await authProvider.getAccessToken() : null;
        const headers: HeadersInit = { "Content-Type": "application/json" };

        if (token) {
          headers["Authorization"] = `Bearer ${token}`;
        }

        const response = await fetch(`${getPartnerAwareApiUrl()}/documents/schemas`, {
          headers,
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch schema definitions: ${response.statusText}`);
        }

        const jsonData = await response.json();
        setData(jsonData);
      } catch (err) {
        console.error("Error fetching schema definitions:", err);
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setLoading(false);
      }
    };

    void fetchSchemas();
  }, []);

  return { data, loading, error };
};
